import MultiLine from 'd3vue/components/MultiLine.vue'
import { keepDimensions, valueAsNumber } from '../dataFilter'
import { toScale } from '../colors'
import api from '../api'

export default {
  id: 'measures-line',
  label: 'Graphique en courbe (Mesures multiples)',
  component: MultiLine,
  multipleMeasure: () => true,
  dimensions: 1,
  adaptater: (data, vue) => {
    const props = {}
    if (vue.colorScheme) {
      props.colorScale = toScale(vue.colorScheme)
    }    
    vue.buildProps(props)
    return keepDimensions(1, data).map(d => {
      const r = {}
      Object.keys(d).forEach(k => {
        r[k] = d[k]
      })
      vue.measure.forEach(m => {
        r[api.measure.name(m)] = valueAsNumber(r[api.measure.name(m)])
      })
      return r
    }).filter(d => !vue.noEmpty || vue.measure.map(m => d[api.measure.name(m)]).some(v => v))
  }
}



// WEBPACK FOOTER //
// ./node_modules/macarons-graphs-front/src/graph/MeasuresLine.js